import React from 'react';
import { S3Image } from '../S3Image';

/** Small cover for the CMS lists. Square (ads) or 16:9-ish (articles); empty when the item has no image. */
export const CmsThumb: React.FC<{ imageKey?: string | null; width: number; height: number; background?: string }> = ({
  imageKey,
  width,
  height,
  background,
}) => (
  <div
    className="shrink-0 overflow-hidden rounded-md bg-gray-100"
    style={{ width, height, background: background || undefined }}
    aria-hidden
  >
    {imageKey ? (
      <S3Image
        imageKey={imageKey}
        alt=""
        showLoading={false}
        fallbackComponent={<span />}
        style={{ width, height, objectFit: 'cover' }}
      />
    ) : null}
  </div>
);
